import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { GlobalContext } from '../../providers/GlobalProvider';
import { Grid } from '@mui/material';
import ExportDesignChatUI from 'components/ExportDesign/ExportDesignChatUI';
import ExportDesignTicket from 'components/ExportDesign/ExportDesignTicket';
import {
  readDesignTicket,
  sampleSavedCase,
  TicketPreviewVariant,
} from 'components/ExportDesign/exportDesignTicketPayload';

// Export Design Advisor page. Mirrors ExportPage's Business+ license gating:
// the tier check drives a `userHasMonitor` flag passed to the chat, which shows a
// RequiredLicense upgrade bar + disables input when the user is below Business.
const ExportDesignPage: React.FC = () => {
  const { cur_user } = useContext(GlobalContext);
  const location = useLocation();
  const [userHasMonitor, setUserHasMonitor] = useState(true);
  // Design mockup of the saved ticket, reachable at /export-design/ticket-preview. The
  // route is already non-exact, so this needs no change to Routes.tsx.
  const showTicketPreview = location.pathname.endsWith('/ticket-preview');
  // ?variant=classification | licensing | design-changes | clean renders the ticket as it looks when the
  // assessment stopped early or only an optional analysis was asked for (default: everything).
  const requestedVariant = new URLSearchParams(location.search).get('variant');
  const previewVariant: TicketPreviewVariant =
    requestedVariant === 'classification' ||
    requestedVariant === 'licensing' ||
    requestedVariant === 'design-changes' ||
    requestedVariant === 'clean'
      ? requestedVariant
      : 'full';

  const requiredTiers = ['business', 'enterprise'];

  useEffect(() => {
    if (
      !requiredTiers.includes(cur_user.license) &&
      cur_user?.bite_super_admin !== true
    ) {
      setUserHasMonitor(false);
    }
  }, []);

  return (
    <section className='standard-workflow-page Home-HeaderDown export-design-page'>
      <div>
        <Grid container>
          <Grid item xs={12}>
            {showTicketPreview ? (
              <ExportDesignTicket ticket={readDesignTicket(sampleSavedCase(previewVariant))} />
            ) : (
              <ExportDesignChatUI userHasMonitor={userHasMonitor} />
            )}
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ExportDesignPage;
